import React from "react";
import ColorHash from 'color-hash';
import { Tooltip, Typography } from "material-ui-core";


export const generateColorMap = (incidentTypes) => {
  const colorHash = new ColorHash();
  const usedColors = new Set();
  const map = {};

  incidentTypes.forEach((type) => {
    let color;
    let attempt = 0;

    do {
      // Generate a color using ColorHash, appending attempt to help prevent collisions
      color = colorHash.hex(type + attempt);
      attempt++;
    } while (usedColors.has(color));

    usedColors.add(color);
    map[type] = color;
  });

  return map;
};



export const statsData = [
  
  {
    label: "Total Incidents",
    iconSrc: "/MDRIcons/MDRPaper.svg",
    iconClass: "paperIcon"
  },
  {
    label: "Open",
    iconSrc: "/MDRIcons/MDRSwap.svg",
    iconClass: "swap"
  },
  {
    label: "True Positive",
    iconSrc: "/MDRIcons/MDRTruepositive.svg",
    iconClass: "offline"
  },
  {
    label: "False Positive",
    iconSrc: "/MDRIcons/MDROfflinePin.svg",
    iconClass: "offline"
  },
  {
    label: "Other",
    iconSrc: "/MDRIcons/MDRGraph.svg",
    iconClass: "graph"
  }
];

export const currentOpenCount = [{
  label: "OpenCount",
  name: "Open Count",
  title: "Current Open issues Count",
  iconSrc: "/MDRIcons/currentOpenCount.svg",
  iconClass: "swap",
  value: 0
}];

export const CurrentOpenCountPill = ({ data }) => {
  return (
    <div className="dashboard-pill-stats">
      {data.map((item, index) => (
        <React.Fragment key={item.label}>
          <div className="pill-item openCount">
            <span className={`pill-icon ${item.iconClass}`}>
              <img src={item.iconSrc} alt={item.title} />
            </span>
            <div className="pill-data">
              <div className="pill-label" title={item.title}>{item.name}</div>
              <div className="pill-value">{item.value}</div>
            </div>
          </div>
          {index !== data.length - 1 && <span className="mdr-pill-separator" />}
        </React.Fragment>
      ))}
    </div>
  );
};




export const PillStats = ({ data }) => {
  return (
    <div className="dashboard-pill-stats">
      {data.map((item, index) => (
        <React.Fragment key={item.label}>
          <div className="pill-item">
            <span className={`pill-icon ${item.iconClass}`}>
              <img src={item.iconSrc} alt={item.label} />
            </span>
            <div className="pill-data">
              <div className="pill-label">{item.label}</div>
              <div className="pill-value">{item.value}</div>
            </div>
          </div>
          {index !== data.length - 1 && <span className="mdr-pill-separator" />}
        </React.Fragment>
      ))}
    </div>
  );
};

export const FilterGroup = ({ title, items, field, toggleFilter, jiraTableFilters, classes }) => {
  const activeFilters = jiraTableFilters[field] || [];
  return (
    <div className="filter-section">
      <Typography variant="body2" className="quick-filters-label">
        {title}:
      </Typography>
      <div className="priority-quick-filters">
        {items.map((item) => {
          const value = item.toLowerCase();
          const isActive = activeFilters.includes(item);
          return (
            <Tooltip key={item} title={item} arrow>
              <div
                className={`${classes}-chip ${value} ${
                  isActive ? "active" : ""
                } filters`}
                onClick={() => toggleFilter(field, item)}
              >
                {item}
              </div>
            </Tooltip>
          );
        })}
      </div>
    </div>
  );
};

